module.exports = __webpack_public_path__ + "static/media/tab-7-image-1.556ea61a.png";